import React from 'react'
import { Button } from 'selfServicePortal/components/ui/Button'
import { MessageCard } from 'selfServicePortal/components/Message/Message'
import { forceNavigateHome } from 'selfServicePortal/utils'
import { useTranslation } from 'react-i18next'

export type StepThreeStatus = {
	state: 'Approved' | 'Denied' | 'error'
	message: string
}

interface StepThreeProps {
	status: StepThreeStatus
}

export function StepThree({ status }: StepThreeProps) {
	const { t } = useTranslation()

	if (status.state === 'Denied') {
		return (
			<MessageCard
				type="fail"
				message={t(`CashToAccountResponses.error.${status.message}`)}
				footer={
					<Button variant="primary" onClick={forceNavigateHome}>
						{t('cashToAccountStepThreeButton')}
					</Button>
				}
			/>
		)
	}
	if (status.state === 'error') {
		return (
			<MessageCard
				type="fail"
				message={t('cashToAccountStepThreeError')}
				footer={
					<Button variant="primary" onClick={forceNavigateHome}>
						{t('cashToAccountStepThreeButton')}
					</Button>
				}
			/>
		)
	}

	return (
		<MessageCard
			type="success"
			message={t('CashToAccountResponses.success.c2a-decision-approved')}
			footer={
				<Button variant="primary" onClick={forceNavigateHome}>
					{t('cashToAccountStepThreeButton')}
				</Button>
			}
		/>
	)
}
